<template>
	<PopupRouterView label="Purchase Order Status Input"  entityName="DocumentType" :documentId="mainRecordId"  @saveMethod="saveAction" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-code" label-cols-sm="4" label-cols-lg="3" label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"  @change="updateData" />
				<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData" />
			</b-col>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DocumentType from '@/models/DocumentType/DocumentType';
import DocumentTypeList from '@/models/DocumentType/DocumentTypeList';
import DocumentTypeFilter from '@/filters/DocumentType/DocumentTypeFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,PopupRouterView},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
			code: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
				code: { required : "Code is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDocumentType : null,
			currentDocumentTypePage : 1,
			documentTypePageSize: 10,
			sortByDocumentType: '',
			sortDescDocumentType: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getDocumentType : async function(id) {
			this.isBusy = true;
			DocumentType.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDocumentType = true;
			this.filterDocumentType.id = this.modelId;
			DocumentType.downloadDataDetail(this, this.filterDocumentType).then(result => {
				this.isDownloadDocumentType = false;
			}).catch(error => { this.isDownloadDocumentType = false; })
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					DocumentType.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'documenttypeindex' });
						this.isBusy = false;
						this.$store.dispatch('addSuccessMessageGlobal', "Data Berhasil disimpan");
					}).catch(error => { this.isBusy = false; });
				} else {
					DocumentType.insertData(this, model).then(result => {
						this.$router.push({ name: 'documenttypeindex' });
						this.isBusy = false;
						this.$store.dispatch('addSuccessMessageGlobal', "Data Berhasil disimpan");
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			/*Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DocumentType.updateData(this, model, id);
				}
			});*/
		},
		onHidden() {
			this.getDocumentTypes();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDocumentType = new DocumentTypeFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDocumentType(id);
			} else {
				this.modelId = id;
				this.getDocumentType(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
		if (!this.isDataCommited) {
			//DocumentType.discardData(this, this.modelId);
		}
	},
}
</script>
